import createReducer from 'arts/config/create_reducer';
import Constants from '../config/const';

const getDefaultState = () => ({
  x: 0,
  width: 0,
  y: 0,
  height: 0,
  custom: false
});

const crop = createReducer(getDefaultState(), {
  [Constants.crop.set]: (_, {
    x, y, width, height
  }) => ({
    x, y, width, height, custom: true
  }),
  [Constants.crop.reset]: (state) => ({
    ...state,
    custom: false
  })
});
export default crop;
